import { TreeNode } from './types';

export function assignDepthAndNumbering(
  nodes: TreeNode[],
  depth: number,
  parentPrefix: string
): void {
  nodes.forEach((node, index) => {
    node.depth = depth;
    const number = index + 1;
    const prefix = parentPrefix ? `${parentPrefix}.${number}` : `${number}`;
    node.displayNumber = prefix;

    if (node.type === 'section' && node.children.length > 0) {
      assignDepthAndNumbering(node.children, depth + 1, prefix);
    }
  });
}
